import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/partners/referrals")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Referral Partner Program · Earn 20% | Shugert",
    description: "Refer a Shopify brand to Shugert and earn 20% of eligible net revenue from the first engagement, up to $5,000 per client.",
    path: "/partners/referrals",
    altPath: alternatePath("/partners/referrals", "es"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Referral partners", path: "/partners/referrals" }]),
      webPageJsonLd({ name: "Shugert Referral Partner Program", path: "/partners/referrals", description: "A referral program for agencies, consultants, developers and technology partners introducing Shopify brands to Shugert.", inLanguage: "en-US" }),
    ],
  }),
});
